import React from 'react';
import ReactMaskedInput from 'react-maskedinput';

import { Input } from '../Form';

const MaskedInput = (props) => <Input component={ReactMaskedInput} {...props} />;

export default MaskedInput;
